document.addEventListener("DOMContentLoaded", (event) => {

let timelineInformationList = gsap.timeline({ 
  scrollTrigger: {
    trigger: ".fading-text",
    start: "top 80%",
    end: "top 20%",
    scrub: true,
    onEnterBack: () => {
    document.querySelectorAll(".fading-text").forEach( el => el.classList.remove("is-animated"));
  },
    onLeaveBack: () => {
   document.querySelectorAll(".fading-text").forEach( el => el.classList.remove("is-animated"));
  }
  },
 });
timelineInformationList.fromTo(
  ".fading-text span",
  {
    opacity: 0,
    rotateY: 90
  },
  {
    opacity: 1,
    rotateY: 0,
    duration: 0.6,
    stagger: {
     each: 0.05,
      onComplete: function () {
       setTimeout(this._targets[0].closest(".fading-text").classList.add("is-animated"))
      }
    },
    ease: "expo.out"      
  }
);

let timelineAboutInformationList = gsap.timeline({ 
  scrollTrigger: {
    trigger: ".fading-text-about",
    start: "top 90%",
    end: "top 50%",
    scrub: true,
    onEnterBack: () => {
    document.querySelectorAll(".fading-text-about").forEach( el => el.classList.remove("is-animated"));
  },
    onLeaveBack: () => {
   document.querySelectorAll(".fading-text-about").forEach( el => el.classList.remove("is-animated"));
  }
  },
 });


 timelineAboutInformationList.fromTo(
  ".fading-text-about span",
  {
    opacity: 0,
    rotateY: 90
  },
  {
    opacity: 1,
    rotateY: 0,
    duration: 0.6,
    stagger: {
     each: 0.05,
      onComplete: function () {
       setTimeout(this._targets[0].closest(".fading-text-about").classList.add("is-animated"))
      }
    },
    ease: "expo.out"      
  }
);

let timelineTextWithImageSection = gsap.timeline({
  scrollTrigger: {
    trigger: "#hb-video",
    start: "top 80%",
    end: '+=700',
    scrub: true,
  }
});
timelineTextWithImageSection.to('#hb-video', { duration: 1.5, opacity: 1 });
 
  if(window.innerWidth < 769) {
    gsap.registerPlugin(ScrollTrigger)

    gsap.to('[js-index-top-information-animation]', { top: 0, duration: 1.5  })

    let timelineTopInformationAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: "[js-index-top-information-animation]",
        start: "top bottom",
        end: '+=720',
        scrub: true,
      }
    });
    timelineTopInformationAnimation.to('[js-overlay-animation]', { duration: 1.5, width: 'calc(100% + 8px)' })
  }

  
  if(window.innerWidth > 768) {
    gsap.registerPlugin(ScrollTrigger)
  
    gsap.to('.template-name-index', { opacity: 1, duration: 1.5 })
    gsap.to('[js-header-animation]', { top: 0, duration: 1.5  })
    gsap.to('[js-hero-banner-content-animation]', { left: 0, duration: 1.5  })
    gsap.to('[js-index-top-information-animation]', { top: 0, duration: 1.5  })
    gsap.to('[js-announcement-bar-animation]', { opacity: 1, duration: 1  }, ">")

    
    ScrollTrigger.create({
      trigger: ".Index_image_overlay_texts_new",
      start: "top 120px",
      scrub: true,
      pin: true,
      pinSpacing: false,
    });

    let timelineTopInformationAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: "[js-index-top-information-animation]",
        start: "top bottom",
        end: '+=1000',
        scrub: true,
      },
    });
    timelineTopInformationAnimation.to('[js-overlay-animation]', { duration: 1.5, width: 'calc(100% + 23px)' })

    let timelineFeatureCollectionSlider = gsap.timeline({
      scrollTrigger: {
        trigger: ".Index_featured_collection_new",
        start: "top bottom",
        end: '+=1500',
        scrub: true,
      }
    });
    timelineFeatureCollectionSlider.fromTo('.hb-index_featured-overlay', { opacity: 0 }, { duration: 2, opacity: 1 });
    timelineFeatureCollectionSlider.to('.Index_featured_collection_parts_maintitle_new', { duration: 1, top: 0 }, "-=2");

    let timelineVideoSection = gsap.timeline({
      scrollTrigger: {
        trigger: ".Index_video_plays_texts_new",
        start: "top bottom",
        end: '+=500',
        scrub: true,
      }
    });
    timelineVideoSection.to('.Index_video_plays_texts_new', { duration: 2, opacity: 1, top: 0 });


    // let timelineInformationList = gsap.timeline({
    //    scrollTrigger: {
    //      trigger: ".Index_informations_lists_new",
    //     start: "top center",
    //     end: '+=500',
    //      scrub: true,
    //   }
    // });
    //  timelineInformationList.to('.Index_informations_lists_new', { duration: 2, opacity: 1 });



  // gasp animation on text scroll

    let timelineTextWithImageSection = gsap.timeline({
      scrollTrigger: {
        trigger: ".Index_texts_with_images_new",
        start: "top bottom",
        end: '+=500',
        scrub: true,
      }
    });
    
    timelineTextWithImageSection.to('.Index_texts_with_images_new', { duration: 1, opacity: 1 });
    timelineTextWithImageSection.to('.Index_texts_with_images_parts_innerleft_new', { left: 0, duration: 1 }, "-=1.5");


    let timelineExpertsTeamSection = gsap.timeline({
      scrollTrigger: {
        trigger: ".Index_experts_member_list_new",
        start: "top bottom",
        end: '+=1200',
        scrub: true,
      }
    });
    timelineExpertsTeamSection.to('.Index_experts_member_list_parts_innertitle_new', { duration: 1.5, top: 0 });
    timelineExpertsTeamSection.to('.Index_experts_member_list_parts_innerloop_innerboxs_new', { rotate: '0deg', top: 0, duration: 1.5 }, "-=2");

    let timelineLogoList = gsap.timeline({
      scrollTrigger: {
        trigger: ".Index_logos_lists_slider_new",
        start: "center bottom",
        end: '+=1000',
        scrub: true,
      }
    });
    timelineLogoList.to('.Index_logos_lists_slider_main_new', { duration: 2, paddingTop: 80, paddingBottom: 80 });

    let timelineFooter = gsap.timeline({
      scrollTrigger: {
        trigger: ".Footer_main_new",
        start: "top bottom",
        end: '+=500',
        scrub: true,
      }
    });
    timelineFooter.to('.Footer_innerparts_mainlogo_new', { duration: 2, top: 0 });

  }
});